import React from 'react';

interface StepIndicatorProps {
	steps: Array<{
		id: string;
		name: string;
		status: 'completed' | 'active' | 'pending';
	}>;
	currentStep: number;
	onStepClick?: (stepIndex: number) => void;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep, onStepClick }) => {
	if (steps.length < 2) return null;
	return (
		<div className='step-indicator'>
			<div className='step-line'>
				{steps.map((step, index) => (
					<React.Fragment key={step.id}>
						<div className={`step-item ${step.status} ${index === currentStep ? 'current' : ''}`} onClick={() => onStepClick && step.status === 'completed' && onStepClick(index)} style={{ cursor: onStepClick && step.status === 'completed' ? 'pointer' : 'default' }}>
							<div className='step-circle' title={step.name}>
								{step.status === 'completed' ? <span className='step-check'>✓</span> : <span className='step-number'></span>}
							</div>
						</div>
						{index < steps.length - 1 && <div className={`step-connector ${index < currentStep ? 'completed' : ''}`}></div>}
					</React.Fragment>
				))}
			</div>
		</div>
	);
};

export default StepIndicator;
